import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'MixandMatchLazy',
        path: () => path.join(__dirname, './MixandMatch'),
        resolve: () => require.resolveWeak('./MixandMatch'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "MixandMatchLazy" */ './MixandMatch')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
